import { CurrencyPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { Transaction } from 'src/models/summary.model';
import { CommonPagesService } from '../../common-pages.service';
import {
  responseMessageStatus,
  ResponseStatus,
  TransactionsType,
} from '../../enum';

@Component({
    selector: 'app-cancel-transaction',
    templateUrl: './cancel-transaction.component.html',
    styleUrls: ['./cancel-transaction.component.scss'],
    standalone: false
})
export class CancelTransactionComponent implements OnInit {
  //#region
  showCancelTransactionModal: boolean = true;
  isLoadingReq: boolean = false;
  sendConfirmVisible: boolean = false;
  @Output() hideCancelPaymentModal = new EventEmitter();
  @Input() transactionType: number;
  @Input() transactionId: string;
  @Input() currentTransactionDetails: Transaction;
  transactoinTypeEnum = TransactionsType;
  radioValue = 'A';
  contact: string;
  amount: string;
  amounToUpdate: number;
  description: string;
  loading: boolean = false;
  supplierId: string;
  //#endregion

  //constructor
  constructor(
    public _fS: FormService,
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    private route: ActivatedRoute,
    private currency: CurrencyPipe
  ) {
    _fS.cancelPaymentForm_fb();
  }

  //#region functions
  ngOnInit(): void {
    this.supplierId = this.route.snapshot.paramMap.get('supplierId');
  }

  handleOk() {
    if (this._fS.cancelPaymentForm.valid) {
      this.sendConfirmVisible = true;
    } else {
      this._cS.markFormGroupTouched(this._fS.cancelPaymentForm);
    }
  }

  cancelTransaction() {
    this.isLoadingReq = true;
    const formValue = this._fS.cancelPaymentForm.value;
    if (this.transactionType == this.transactoinTypeEnum.Payment) {
      const cancelData = new FormData();
      cancelData.set('PaymentId', this.transactionId);
      cancelData.set('Reason', formValue.reason);
      this._cpS.cancelPayment(cancelData).subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isLoadingReq = false;
          this.sendConfirmVisible = false;
          this.handleCancel(
            this.transactionId,
            this.transactionType,
            this.currentTransactionDetails.transactionsStatus,
            false
          );
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
        } else {
          this.isLoadingReq = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
    } else {
      const cancelData = new FormData();
      cancelData.set('InvestmentId', this.transactionId);
      cancelData.set('Reason', formValue.reason);
      this._cpS.cancelInvoice(cancelData).subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isLoadingReq = false;
          this.sendConfirmVisible = false;
          this.handleCancel(
            this.transactionId,
            this.transactionType,
            this.currentTransactionDetails?.transactionsStatus,
            false
          );
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
        } else {
          this.isLoadingReq = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
    }
  }
  //format entered number on blur
  formatAmount(amount: string) {
    if (amount) {
      if (amount.includes('$')) {
        amount = amount.split('$')[1];
      }
      amount = amount.replace(',', '');
      this.amounToUpdate = Number(amount);
      // this._fS.paymentForm.patchValue({
      this.amount = this.currency.transform(amount);
      // });
    }
  }
  pasteToNewDesc() {
    if (!this.description) {
      this.description = this.currentTransactionDetails.description;
    }
    this.copyMessage(this.currentTransactionDetails.description);
  }
  isDescCopied: boolean = false;
  copyMessage(val: string) {
    this.isDescCopied = true;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    setTimeout(() => {
      this.isDescCopied = false;
    }, 1000);
  }
  editTransaction() {
    const formValue = this._fS.cancelPaymentForm.value;
    this.isLoadingReq = true;
    const editData = new FormData();
    editData.set('InvestmentId', this.transactionId);
    editData.set('Contact', this.contact ? this.contact : '');
    editData.set('Amount', (this.amount ? this.amount : '') + '');
    editData.set('Description', this.description ? this.description : '');
    editData.set('Reason', formValue.reason);

    this._cpS.updateInvestmentRequest(editData).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isLoadingReq = false;
        this.sendConfirmVisible = false;
        this.handleCancel(this.transactionId, null, null, true);
        this._cS.displayMessage(
          responseMessageStatus.success,
          response.message
        );
      } else {
        this.isLoadingReq = false;
      }
    });
  }
  handleCancelSend() {
    this.sendConfirmVisible = false;
  }
  handleCancel(
    transactionId: any,
    transactionType: any,
    transactionStatus: any,
    isEdit: boolean
  ) {
    this.showCancelTransactionModal = false;
    this.hideCancelPaymentModal.emit({
      isVisible: this.showCancelTransactionModal,
      transactionId: transactionId,
      transactionType: transactionType,
      transactionStatus: transactionStatus,
      isEdit: isEdit,
    });
  }
  //#endregion
}
